<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Requirements</h3>
           </template>
            <nav class="row">
                 <ol class="breadcrumb arr-right bg-breadcrum">
                    <li class="breadcrumb-item">
                       <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item active">Requirements</li>
                 </ol>
              </nav>
           <hr style="margin-top:-10px"/>
           <div class="row">
              <div class="col-md-5">
                 <p><i class="fa fa-search"></i> Search Employee</p>
                 <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
              </div>
              <div class="col-md-3">
                 <div class="form-group">
                    <p><i class="fa fa-filter"></i>&nbsp;Filter by Position:</p>
                    <select v-model="filter_by_position" class="form-control" required>
                       <option value="">Default</option>
                       <option v-for="pos in positions"  v-text="pos.pos_name"></option>
                    </select>
                 </div>
              </div>
              <div class="col-md-1">
                 <div class="form-group">
                    <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                    <select v-model="page_limit" class="form-control" required>
                       <option value="">Default</option>
                       <option value="10">10</option>
                       <option value="25">25</option>
                       <option value="100">100</option>
                    </select>
                 </div>
              </div>
              <div class="col-md-1">
                 <div class="form-group">
                    <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                    <select v-model="order_by" class="form-control" required>
                       <option value="">Default</option>
                       <option value="-1">ASC</option>
                       <option value="1">DESC</option>
                    </select>
                 </div>
              </div>
              <div class="col-md-2">
                 <div class="form-group">
                    <p><i class="fa fa-filter"></i>&nbsp;Filter by Status:</p>
                    <select v-model="filter_by_status" class="form-control" required>
                       <option value="">Default</option>
                       <option value="submitted">Completed Requirements</option>
                       <option value="notsubmitted">Lacking Requirements</option>
                    </select>
                 </div>
              </div>
           </div>
           <hr/>
           <div class="table-responsive">
              <table class="table table-striped table-hover table-header-rotated"  v-loading="loading">
                 <thead>
                    <tr> 
                       <th>#</th>
                       <th>EMPLOYEE</th>
                       <th>STATUS</th>
                       <th class="rotate-45"><div><span>SSS </span></div></th>
                       <th class="rotate-45"><div><span>HDMF</span></div></th>
                       <th class="rotate-45"><div><span>MID</span></div></th>
                       <th class="rotate-45"><div><span>TIN</span></div></th>
                       <th class="rotate-45"><div><span>Phic</span></div></th>
                       <th class="rotate-45"><div><span>TOR</span></div></th>
                       <th class="rotate-45"><div><span>2316</span></div></th>
                       <th class="rotate-45"><div><span>COE</span></div></th>
                       <th class="rotate-45"><div><span>NBI</span></div></th>
                       <th class="rotate-45"><div><span>NSO/BIRTH</span></div></th>
                       <th class="rotate-45"><div><span>Brgy Clearance</span></div></th>
                       <th class="rotate-45"><div><span>Police Clearance</span></div></th>
                       <th class="rotate-45"><div><span>ID Pictures</span></div></th>
                       <th class="rotate-45"><div><span>Mariage Contract</span></div></th>
                       <th class="rotate-45"><div><span>SSS STATIC</span></div></th>
                       <th class="rotate-45"><div><span>photocopy SSS</span></div></th>
                       <th class="rotate-45"><div><span>photocopy PHIC</span></div></th>
                       <th class="rotate-45"><div><span>photocopy HDMF</span></div></th>
                       <th class="rotate-45"><div><span>photocopy TIN</span></div></th>
                       <th class="rotate-45"><div><span>NSO Dependents</span></div></th>
                       <th width="100"></th>
                    </tr>
                 </thead>
                 <tbody>
                    <tr v-for="(item,index) in  computedRequirements" >
                        <template v-if="item === 'no data found'">
                           <td colspan="100%"><h4>  <i class="fa fa-database"></i> Empty Records ...</h4></td>  
                        </template>   
                        <template v-else>
                            <td>{{index+1}}</td>
                            <td>
                                <a href="#" @click="get_selected_id(item)" class="link-default-requirements" v-b-modal.update-record  v-b-tooltip.hover title="click to update employee requirements record"><u>{{item.full_name | capitalize}} </u></a>&nbsp;
                            </td>
                            <td>
                                <span v-if="
                                    (item.sss_no !== null) &&
                                    (item.hdmf_no !== null) &&
                                    (item.tin_no !== null) &&
                                    (item.phic_no !== null) &&
                                    (item.mid_no !== null) &&
                                    (item.TOR == 'submitted') &&  
                                    (item.ITW == 'submitted') && 
                                    (item.COE == 'submitted') &&
                                    (item.NBI == 'submitted') &&
                                    (item.NSO_BC == 'submitted') &&
                                    (item.barangay_clearance == 'submitted') &&
                                    (item.police_clearance == 'submitted') &&  
                                    (item.id_picture == 'submitted') &&
                                    (item.sss_static == 'submitted') &&
                                    (item.photocopy_sss == 'submitted') &&
                                    (item.photocopy_phic == 'submitted') &&
                                    (item.photocopy_hdmf == 'submitted') &&
                                    (item.photocopy_tin == 'submitted')  && 
                                    (item.nso_dependents == 'submitted') 
                                    " 
                                    class="enable"><i class="fa fa-star-o"></i>&nbsp;Completed </span>
                                <span v-else class="disable">
                                     <i class="fa fa-thumb-tack"></i>&nbsp;Lacking&nbsp;<span class="badge badge-pill badge-danger">
                                </span>
                                </span>     
                            </td>
                            <td>
                                <span v-if="item.sss_no !== null"><i class="fa fa-check enable"></i></span>
                                <span v-else><i class="fa fa-times disable" v-b-tooltip.hover title="SSS - (Social Security System) "></i></span> 
                            </td>
                            <td>
                                <span v-if="item.hdmf_no !== null"><i class="fa fa-check enable"></i></span>
                                <span v-else><i class="fa fa-times disable" v-b-tooltip.hover title="HDMF - (Home Development Mutual Fund) "></i></span>  
                            </td>
                            <td>
                                <span v-if="item.mid_no !== null"><i class="fa fa-check enable"></i></span>
                                <span v-else><i class="fa fa-times disable" v-b-tooltip.hover title="HDMF - (Home Development Mutual Fund) "></i></span>  
                            </td>
                            <td>
                                <span v-if="item.tin_no !== null"><i class="fa fa-check enable"></i></span>
                                <span v-else><i class="fa fa-times disable" v-b-tooltip.hover title="TIN - (Taxpayer Identification Number)"></i></span>  
                            </td>
                            <td>
                                <span v-if="item.phic_no !== null"><i class="fa fa-check enable"></i></span>
                                <span v-else><i class="fa fa-times disable" v-b-tooltip.hover title="Philhealth No."></i></span>  
                            </td>
                            <td>
                                <span v-if="item.TOR == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="TOR - (Transcript Of Record)"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                            <td>
                                <span v-if="item.ITW == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="2316"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                            <td>
                                <span v-if="item.COE == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="COE - (Certificate Of Employment)"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                            <td>
                                <span v-if="item.NBI == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="NBI - (National Bureau of Investigation)"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                            <td>
                                <span v-if="item.NSO_BC == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="NSO/Birth Certificate"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                            <td>
                                <span v-if="item.barangay_clearance == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="BCLR - (Barangay Clearance)"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                            <td>
                                <span v-if="item.police_clearance == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="PCLR - (Police Clearance)"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                            <td>
                                <span v-if="item.id_picture == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="Pics - (1x1 and 2x2 Picture)"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                            <td>
                                <span v-if="item.MC == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="MC - (Married's Contract) if Married"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                             <td>
                                <span v-if="item.sss_static == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="SSS Static"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                             <td>
                                <span v-if="item.photocopy_sss == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="Photocopy of SSS"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                             <td>
                                <span v-if="item.photocopy_phic == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="Photocopy PHIC"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                             <td>
                                <span v-if="item.photocopy_hdmf == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="Photocopy HDMF"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                             <td>
                                <span v-if="item.photocopy_tin == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="Photocopy TIN"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                            <td>
                                <span v-if="item.nso_dependents == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="NSO Dependents"></i></span>
                                <span v-else><i class="fa fa-check enable"></i></span>     
                            </td>
                            <td> 
                                <span v-if="item.note !== null">
                                <a href="#" @click="get_selected_id(item)" v-b-modal.update-notes class="btn btn-xs btn-success" v-b-tooltip.hover title="click to view a notes">
                                <i class="fa fa-eye"></i>View
                                </a>
                                </span> 
                                <span v-else>
                                <a href="#" @click="get_selected_id(item)" v-b-modal.update-notes class="btn btn-default btn-xs" v-b-tooltip.hover title="click add notes to create a new notes or reminders"><i class="fa fa-plus"></i>
                                Add 
                                </a>
                                </span>    
                            </td>
                        </template>
                    </tr>
                 </tbody>
              </table>    
              <!-- PAGINATION   -->
             
                <!-- <button @click="prev_page">prev</button> -->
                
                <!-- PREV BUTTON -->
                    <!-- <span v-if="start_page > 1"><button @click="prev_page" class="btn btn-sm btn-info">Prev</button></span>
                   <span v-else><button class="btn btn-sm btn-default not-allowed">Prev</button></span> -->
                <!-- NEXT BUTTON-->
                    <!-- <span v-if="start_page <= numOfPages - 1"><button @click="next_page" class="btn btn-sm btn-info">Next</button></span>
                    <span v-else><button class="btn btn-sm btn-default not-allowed">Next</button></span> -->
    
               <!-- numOfPages:{{numOfPages}} <br/>
               offset : {{offset}}<br/>
               limit:{{limit}}<br/>
               total_record:{{total_record}}<br/>
               start_page: {{start_page}} -->
    
    
             <!-- MODAL AREA -->
           <b-modal id="update-record"  ref="update-modal-hide" size="xl"   title="Update Record"  hide-footer no-stacking>
                <h2>{{selectedUser.full_name | capitalize}}</h2>
                <hr/>
                <div class="row">
                   <div class="col-md-4">
                      <div class="form-group">
                         <label>SSS No.</label>
                         <the-mask :mask="['##-#######-#']" placeholder="00-0000000-0"  class="form-control" v-model="selectedUser.sss_no"/>
                      </div>
                   </div>
                   <div class="col-md-4">
                      <div class="form-group">
                         <label>HDMF NO.</label>
                         <the-mask :mask="['####-####-####']" placeholder="0000-0000-0000" class="form-control" v-model="selectedUser.hdmf_no"/>
                      </div>
                   </div>
                   <div class="col-md-4">
                      <div class="form-group">
                         <label>MID NO.</label>               
                         <the-mask :mask="['####-####-####']" placeholder="000-000-000" class="form-control" v-model="selectedUser.mid_no"/>
                      </div>
                   </div>
                   <div class="col-md-4">
                      <div class="form-group">
                         <label>TIN NO.</label>               
                         <the-mask :mask="['####-####-####']" placeholder="000-000-000" class="form-control" v-model="selectedUser.tin_no"/>
                      </div>
                   </div>
                   <div class="col-md-4">
                      <div class="form-group">
                         <label>PHILHEALTH NO.</label>
                         <the-mask :mask="['##-#########-#']" placeholder="00-000000000-0" class="form-control" v-model="selectedUser.phic_no"/>
                      </div>
                   </div>
                </div>
                <hr>
                <div class="row">
                   <div class="col-md-2">
                      <div class="form-group">
                         <label>TOR.</label>
                         <span v-if="selectedUser.TOR == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="TOR Not Yet Sumitted"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.TOR">
                            <option v-bind:value="selectedUser.TOR" disabled>{{selectedUser.TOR}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                   <div class="col-md-2">
                      <div class="form-group">
                         <label>2316.</label>
                         <span v-if="selectedUser.ITW == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="TOR Not Yet Sumitted"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.ITW">
                            <option v-bind:value="selectedUser.ITW" disabled>{{selectedUser.ITW}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                   <div class="col-md-2">
                      <div class="form-group">
                         <label>COE.</label>
                         <span v-if="selectedUser.COE == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="COE Not Yet Sumitted"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.COE">
                            <option v-bind:value="selectedUser.COE" disabled>{{selectedUser.COE}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                   <div class="col-md-2">
                      <div class="form-group">
                         <label>NBI.</label>
                         <span v-if="selectedUser.NBI == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="NBI Not Yet Sumitted"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.NBI">
                            <option v-bind:value="selectedUser.NBI" disabled>{{selectedUser.NBI}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                   <div class="col-md-2">
                      <div class="form-group">
                         <label>NSO_BC.</label>
                         <span v-if="selectedUser.NSO_BC == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="NSO_BC Not Yet Sumitted"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.NSO_BC">
                            <option v-bind:value="selectedUser.NSO_BC" disabled>{{selectedUser.NSO_BC}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                   <div class="col-md-2">
                      <div class="form-group">
                         <label>Brgy Clearance.</label>
                         <span v-if="selectedUser.barangay_clearance == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="barangay_clearance Not Yet Sumitted"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.barangay_clearance">
                            <option v-bind:value="selectedUser.barangay_clearance" disabled>{{selectedUser.barangay_clearance}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                   <div class="col-md-2">
                      <div class="form-group">
                         <label>Police Clearance.</label>
                         <span v-if="selectedUser.police_clearance == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="police_clearance Not Yet Sumitted"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.police_clearance">
                            <option v-bind:value="selectedUser.police_clearance" disabled>{{selectedUser.police_clearance}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                   <div class="col-md-2">
                      <div class="form-group">
                         <label>ID Picture.</label>
                         <span v-if="selectedUser.id_picture == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="id_picture Not Yet Sumitted"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.id_picture">
                            <option v-bind:value="selectedUser.id_picture" disabled>{{selectedUser.id_picture}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                   <div class="col-md-2">
                      <div class="form-group">
                         <label>MC.</label>
                         <span v-if="selectedUser.MC == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="MC Not Yet Sumitted"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.MC">
                            <option v-bind:value="selectedUser.MC" disabled>{{selectedUser.MC}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                   <!-- NEW ADDITIONAL -->
                     <div class="col-md-2">
                        <div class="form-group">
                           <label>SSS Static</label>
                           <span v-if="selectedUser.sss_static == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="SSS Static"></i></span>
                           <span v-else><i class="fa fa-check enable"></i></span>     
                           <select class="form-control" v-model="selectedUser.sss_static">
                              <span v-if="error_handler.sss_static" class="invalid-feedback">{{ error_handler.sss_static[0] }}</span>
                              <option v-bind:value="selectedUser.sss_static" disabled>{{selectedUser.sss_static}}</option>
                              <option value="none">none</option>
                              <option value="submitted">submitted</option>
                           </select>
                        </div>
                     </div>
                      <div class="col-md-2">
                      <div class="form-group">
                         <label>Photocopy SSS</label>
                         <span v-if="selectedUser.photocopy_sss == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="Photocopy SSS"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.photocopy_sss">
                            <option v-bind:value="selectedUser.photocopy_sss" disabled>{{selectedUser.photocopy_sss}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                    <div class="col-md-2">
                      <div class="form-group">
                         <label>Photocopy Phic</label>
                         <span v-if="selectedUser.photocopy_phic == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="Photocopy Phic"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.photocopy_phic">
                            <option v-bind:value="selectedUser.photocopy_phic" disabled>{{selectedUser.photocopy_phic}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                    <div class="col-md-2">
                      <div class="form-group">
                         <label>photocopy_hdmf</label>
                         <span v-if="selectedUser.photocopy_hdmf == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="Photocopy HDMF"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.photocopy_hdmf">
                            <option v-bind:value="selectedUser.photocopy_hdmf" disabled>{{selectedUser.photocopy_hdmf}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                    <div class="col-md-2">
                      <div class="form-group">
                         <label>photocopy_tin</label>
                         <span v-if="selectedUser.photocopy_tin == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="Photocopy TIN"></i></span>
                         <span v-else><i class="fa fa-check enable"></i></span>     
                         <select class="form-control" v-model="selectedUser.photocopy_tin">
                            <option v-bind:value="selectedUser.photocopy_tin" disabled>{{selectedUser.photocopy_tin}}</option>
                            <option value="none">none</option>
                            <option value="submitted">submitted</option>
                         </select>
                      </div>
                   </div>
                   <div class="col-md-2">
                    <div class="form-group">
                       <label>NSO Dependents</label>
                       <span v-if="selectedUser.nso_dependents == 'none'"><i class="fa fa-times disable" v-b-tooltip.hover title="NSO Dependents"></i></span>
                       <span v-else><i class="fa fa-check enable"></i></span>     
                       <select class="form-control" v-model="selectedUser.nso_dependents">
                          <option v-bind:value="selectedUser.nso_dependents" disabled>{{selectedUser.photocopy_tin}}</option>
                          <option value="none">none</option>
                          <option value="submitted">submitted</option>
                       </select>
                    </div>
                 </div>
                <!-- END -->
                </div>
                <hr>
                <div class="row">
                   <div class="col-md-12">
                      <div class="form-group">
                         <button @click="update_requirements" class="btn btn-info float-right"><i class="fa fa-save"></i> Update Record</button><br/>
                      </div>
                   </div>
                </div>
             </b-modal>
             <!-- NOTES  -->
             <b-modal id="update-notes"  ref="update-notes" size="lg"   title="Notes"  hide-footer no-stacking>
                <h3>{{selectedUser.full_name | capitalize}}</h3>
                <div class="form-group">
                   <textarea class="form-control" rows="10" id="comment" v-model="selectedUser.note" style="background:#fcdf88;color:#000;border-radius: 0px; border:0px;"></textarea>
                </div>
                <div class="form-group">
                   <button @click="update_requirements" class="btn btn-info float-right"><i class="fa fa-save"></i> Save Notes</button>
                </div>
             </b-modal>
           </div>
             <!-- If Lost Connection on Server -->   
             <template v-if="display_indicator === 1">
                <center>
                    <br/><br/>
                    <img  src="/static/img/warning.png"  width="225" height="190">
                     <h1>You've lost your network connection</h1>
                   <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
                   <br/><br/>
              </center>
            </template>
        </card>
     </template>
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'     
    export default {
        components: {
            Card,
        },
        data(){
            return {
               items:[],
               selectedUser: '',
               positions:[],
               //filter
               filter_by_position:'',
               filter_by_status:'',
               search:'',
               order_by:'',
               sortAsc:true,
               //pagination
               page_limit:100,
               start_page:1,
               loading: true, 
    
               paginate: ['computedRequirements'],
               //Indicator
               display_indicator:'',
                // Errors handler
               error_handler:[]
            }
        },
        mounted: function() {
           this.get_requirements()
           this.get_positions()
        },
        methods:{
            get_requirements(){
                axios.get('api/requirements')
                     .then(response => { 
                         this.items = response.data; 
                         this.display_indicator = 2;
                         this.loading = false;
                        })  
                    .catch(error => { 
                         console.log(error.response)  
                         this.display_indicator = 1;
                        });
            },
            
            get_selected_id(item) {
                this.selectedUser = item;
              
            },
            get_positions(){
                axios.get('api/positions')
                     .then(response => {  this.positions = response.data; })
                     .catch(error => { console.log(error) });
            },
            update_requirements(e){
                e.preventDefault();
                let req = JSON.stringify(this.selectedUser);
                axios.post('api/requirements/update/'+ this.selectedUser.id , 
                {
                    'sss_no' : this.selectedUser.sss_no,
                    'hdmf_no' : this.selectedUser.hdmf_no,
                    'mid_no' : this.selectedUser.mid_no,
                    'tin_no': this.selectedUser.tin_no,
                    'phic_no': this.selectedUser.phic_no,
                    'TOR': this.selectedUser.TOR,
                    'ITW': this.selectedUser.ITW,
                    'COE': this.selectedUser.COE,
                    'NBI': this.selectedUser.NBI,
                    'NSO_BC': this.selectedUser.NSO_BC,
                    'barangay_clearance': this.selectedUser.barangay_clearance,
                    'police_clearance': this.selectedUser.police_clearance,
                    'id_picture': this.selectedUser.id_picture,
                    'MC': this.selectedUser.MC,
                    "sss_static": this.selectedUser.sss_static,
                    "photocopy_sss": this.selectedUser.photocopy_sss,
                    "photocopy_phic": this.selectedUser.photocopy_phic,
                    "photocopy_hdmf": this.selectedUser.photocopy_hdmf,
                    "photocopy_tin": this.selectedUser.photocopy_tin,
                    "nso_dependents": this.selectedUser.nso_dependents,
                    "note": this.selectedUser.note
                })
                .then(resp => {
                     this.$router.push({name: 'requirements'}); 
                     this.$swal({
                        type: 'success',
                        title: 'Save',
                        text: 'You successfully save',
                        showConfirmButton: false,
                        timer: 300
                    })
                     this.$refs['update-modal-hide'].hide()
                     this.$refs['update-notes'].hide()
                     this.get_requirements()
                })
               .catch(error => {
                    if (error.response.status == 422){
                          this.error_handler = error.response.data.errors 
                     }
                })
    
              },
              // PAGINATION NEXT & PREV
              next_page(){
                this.start_page ++;
              },
      
              prev_page(){
                this.start_page --;
              },
              
        },
        computed:{
               // PAGINATION
                offset() {
                      return ((this.start_page - 1) * this.page_limit);
                },
         
                limit() {
                      return ((this.offset + this.page_limit));
                }, 
    
                total_record(){
                     return this.items.length
                },
    
                 numOfPages(){
                      return Math.ceil(this.items.length / this.page_limit);
                },  
                computedRequirements(){     
                    let filtered = this.items
                     // if greater than zero display record 
                        if(filtered.length > 0){   
                           // SEARCH BY EMPLOYEE FULLNAME  
                            if(this.search) {
                                filtered = filtered.filter(
                                item => item.full_name.toLowerCase().indexOf(this.search) > -1
                                );
                            return filtered
                            } 
                           // FILTER BY POSITION
                            if(this.filter_by_position){
                            filtered = filtered.filter(
                                item => item.position_name.toLowerCase() === this.filter_by_position.toLowerCase()
                            );  
                            return filtered
                            }
                           // SORTING NUMBER OF DISPLAY
                            if(this.page_limit){
                                filtered =  filtered.slice(this.offset, this.limit);
                                return filtered
                            }
                           // ORDER BY ASC AND DESC COMBOBOX
                            if(this.order_by){
                                filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by )
                                return filtered
                            }
                           // FILTER BY STATUS COMPLETED OR LACKING
                            if(this.filter_by_status === 'submitted'){
                                filtered = filtered.slice(0).filter(
                                    item => 
                                        item.TOR === this.filter_by_status && 
                                        item.ITW === this.filter_by_status && 
                                        item.COE === this.filter_by_status &&
                                        item.NBI === this.filter_by_status &&
                                        item.NSO_BC === this.filter_by_status &&
                                        item.barangay_clearance === this.filter_by_status &&
                                        item.police_clearance === this.filter_by_status &&
                                        item.id_picture === this.filter_by_status &&
                                        item.MC === this.filter_by_status && 
                                        item.sss_static === this.filter_by_status &&
                                        item.photocopy_sss === this.filter_by_status &&
                                        item.photocopy_phic === this.filter_by_status &&
                                        item.photocopy_hdmf === this.filter_by_status &&
                                        item.photocopy_tin === this.filter_by_status &&
                                        item.sss_no > 1 &&  item.hdmf_no > 1 && item.mid_no > 1 && item.tin_no > 1 && item.phic_no                
                                    );
                                return filtered
                            }  
                            if(this.filter_by_status === 'notsubmitted'){
                                filtered = filtered.slice(0).filter(
                                    item => 
                                        item.TOR < 1 ||
                                        item.ITW < 1 || 
                                        item.COE < 1 ||
                                        item.NBI < 1 ||
                                        item.NSO_BC < 1 ||
                                        item.barangay_clearance < 1 ||
                                        item.police_clearance < 1 ||
                                        item.id_picture < 1 ||
                                        item.MC < 1 || 
                                        item.sss_static < 1 || 
                                        item.photocopy_sss < 1 || 
                                        item.photocopy_phic < 1 || 
                                        item.photocopy_hdmf < 1 || 
                                        item.photocopy_tin < 1 || 
                                        (item.sss_no < 1 ||  item.hdmf_no < 1 ) &&  (item.phic_no < 1 ||   item.tin_no < 1 ) || item.mid_no < 1
                            );
                                return filtered
                            }
                       }
    
                    return filtered
                },
         },
    }
    </script>
    <style>
        .enable{
            color:#28a745;
        }
        .disable{
            color:#dc3545;
        }
        .link-default-requirements{
            color: #666;
         }
       
       .rednotes{
            background:#28a745;
            border: 0px solid #28a745;
            padding:7px 11px 7px 11px;
            color: #fff;
        }
    
        .rednotes.a:hover{
            color: #fff;
        }
    
        .readnotes.a:visited{
            color:#fff;
        }
        .bg-breadcrum{
            background:#fff;
        }
    
        .not-allowed {
            cursor: not-allowed !important;
        }
        .table-header-rotated th.row-header{
            width: auto;
        }
        
        .table-header-rotated td{
        width: 40px;
        border-top: 1px solid #dddddd;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        vertical-align: middle;
        text-align: center;
        }
        
        .table-header-rotated th.rotate-45{
        height: 80px;
        width: 40px;
        min-width: 40px;
        max-width: 40px;
        position: relative;
        vertical-align: bottom;
        padding: 0;
        font-size: 12px;
        line-height: 0.8;
        }
        
        .table-header-rotated th.rotate-45 > div{
        position: relative;
        top: 0px;
        left: 40px; /* 80 * tan(45) / 2 = 40 where 80 is the height on the cell and 45 is the transform angle*/
        height: 100%;
        -ms-transform:skew(-45deg,0deg);
        -moz-transform:skew(-45deg,0deg);
        -webkit-transform:skew(-45deg,0deg);
        -o-transform:skew(-45deg,0deg);
        transform:skew(-45deg,0deg);
        overflow: hidden;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #666;
        border-top: 1px solid #dddddd;
        background: #f3ee5f;
        color:#666;
        }
        
        .table-header-rotated th.rotate-45 span {
        -ms-transform:skew(45deg,0deg) rotate(315deg);
        -moz-transform:skew(45deg,0deg) rotate(315deg);
        -webkit-transform:skew(45deg,0deg) rotate(315deg);
        -o-transform:skew(45deg,0deg) rotate(315deg);
        transform:skew(45deg,0deg) rotate(315deg);
        position: absolute;
        bottom: 30px; /* 40 cos(45) = 28 with an additional 2px margin*/
        left: -25px; /*Because it looked good, but there is probably a mathematical link here as well*/
        display: inline-block;
        width: 85px; /* 80 / cos(45) - 40 cos (45) = 85 where 80 is the height of the cell, 40 the width of the cell and 45 the transform angle*/
        text-align: left;
        }
        
    </style>
         
    


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-requirements/todo-requirements.vue